module.exports = __webpack_public_path__ + "img/20200912_154837.13ea73cd.jpg";